import { DELETE, GET, POST, PUT } from './api';

const table = 'cobrancas';

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
};

// Importacao da carteira: o arquivo ja precisa estar na biblioteca de midia
// (POST /upload). Tudo ou nada — o back devolve 400 com o relatorio completo
// em error.details quando o arquivo tem erro.
export const Importar = async (params) => {
  return await POST(`/${table}/importar`, params, true);
};

// Baixa de titulos em lote: irmao do importar — mesmo fluxo de upload, mesmo
// tudo-ou-nada, mesmo formato de relatorio. O que muda e o layout da planilha
// e o relatorio, que traz `baixados` e `contratos` no lugar de `importados`
// e `cobrancas_criadas`.
export const BaixarLote = async (params) => {
  return await POST(`/${table}/baixarlote`, params, true);
};

// Disparo manual da regua. A fila e montada pelo backend todo dia as 06:30,
// mas nada sai sozinho: as mensagens so vao para o WhatsApp quando alguem
// aciona esta rota. `data.simular: true` apura o que sairia sem enviar nada —
// e o primeiro passo da confirmacao, ver components/Modal/BillingRunDunning.
// Cada chamada envia no maximo 500 mensagens; o que sobrar sai na proxima.
//
// Chamada com `authenticated = false` de proposito: o 403 desta rota significa
// usuario sem a flag `executar_regua` (ou sem distribuidor), e nao sessao
// expirada. Com `true`, o ServerFetch apagaria o `user` do storage a cada
// clique de quem nao tem permissao. O cookie vai do mesmo jeito.
export const RunDunning = async (params = {}) => {
  return await POST(`/${table}/regua/executar`, params, false);
};

// Conclui a renegociacao numa transacao so: cria a cobranca nova, baixa os
// titulos renegociados da original, atualiza a original e grava o log. `id` e
// a cobranca ORIGINAL. O corpo leva so as escolhas do operador e os valores
// calculados no modal (`parcelas` sao numeros, sem a linha "Saldo a Vencer",
// que vai como `saldo_a_vencer`) — ver components/Modal/BankingRenegociacao e
// docs/renegociacao-concluir-backend-resposta.md.
//
// Diferente das rotas antigas, o erro volta com o codigo HTTP de verdade, no
// formato do Strapi v4, que o `exposeStrapiError` trata.
//
// Chamada com `authenticated = false` de proposito: o 403 desta rota significa
// usuario sem a flag `cobranca` ou contrato fora do escopo dele, e nao sessao
// expirada (mesmo caso do RunDunning).
export const ConcludeRenegotiation = async (id, params) => {
  return await POST(`/${table}/${id}/renegociacao/concluir`, params, false);
};

// Cancela uma renegociacao concluida, numa transacao so: a cobranca nova vira
// `cancelado` (todos os titulos baixados com `tipo_baixa: cancelado`) e a
// original volta a ser cobrada, com os titulos restaurados e a regua reaberta.
// `id` e a cobranca NOVA (a X-R1), nao a original. O corpo leva so a
// `justificativa`, obrigatoria. Ver components/Modal/BillingCancelRenegotiation
// e docs/renegociacao-cancelamento-entrada-backend.md.
//
// Chamada com `authenticated = false` de proposito: o 403 desta rota significa
// usuario sem a flag `cancela_renegociacao`, e nao sessao expirada (mesmo caso
// do RunDunning).
export const CancelRenegotiation = async (id, params) => {
  return await POST(`/${table}/${id}/renegociacao/cancelar`, params, false);
};

// Baixa manual de titulos, pela aba Baixa do modal de Historico (ver
// components/Modal/HistoricoCobranca/components/Baixa). `id` e a cobranca; o
// corpo leva `{ parcela, valor_recebido, data_baixa }`, um objeto ou uma
// lista, e opcionalmente `perc_desconto` e `valor_desconto`, que o backend
// confere com o valor recebido (tolerancia de R$ 0,01). `data_baixa`
// (AAAA-MM-DD) e obrigatoria em todo item, entrada inclusive: e a data real do
// pagamento, nao pode ser futura nem anterior a emissao do titulo, e o backend
// recalcula juros, multa e IOF ate ela (pagamento ate o vencimento fica sem
// mora). O tipo (normal) e o resto do titulo sao decididos pelo backend, que
// ignora qualquer outro campo. Tudo ou nada: se uma parcela falhar na
// validacao, nenhuma e baixada. O erro volta com o codigo HTTP de verdade.
//
// Chamada com `authenticated = false` de proposito: o 403 desta rota significa
// usuario sem a flag `baixa_manual`, e nao sessao expirada (mesmo caso do
// RunDunning).
export const baixaParcela = async (params, id) => {
  return await PUT(`/${table}/baixaparcela/${id}`, params, false);
};

// Estorno de baixa: desfaz a baixa de um ou mais titulos da cobranca `id`,
// pela aba Baixa do modal de Historico (ver
// components/Modal/HistoricoCobranca/components/Estorno). O corpo leva
// `{ parcelas: [3, 4], justificativa }` (a entrada e a parcela 0), e a
// justificativa e obrigatoria e vai para o log `cancelamento_baixa`. So vale
// para titulo baixado com `tipo_baixa: normal` e sem `renegociar`; o resto
// volta 400 (a renegociacao se desfaz pelo CancelRenegotiation). O backend
// devolve o titulo para `vencido`/`aberto` e recalcula atraso e mora ate hoje.
// Tudo ou nada: se uma parcela falhar, nenhuma e estornada.
//
// Chamada com `authenticated = false` de proposito: o 403 desta rota significa
// usuario sem a flag `estorna_baixa`, e nao sessao expirada (mesmo caso do
// RunDunning).
export const ReverseSettlement = async (id, params) => {
  return await PUT(`/${table}/cancelabaixa/${id}`, params, false);
};

export const msgRenegociacaoCliente = async (params, id) => {
  return await PUT(`/${table}/msgrenegociacaocliente/${id}`, params, true);
};

// Encaminhamento para a esteira juridica. O destino vai no CAMINHO
// (`/cobrancas/:id/notificacao` ou `/execucao`) — existe tambem um
// `PUT /cobrancas/:id/status` generico, que so vale a pena no dia em que
// houver um terceiro destino.
//
// O corpo leva a `observacao`, que entra no log de auditoria junto com quem
// fez e quando — e, por enquanto, o proprio `status` (ver abaixo).
//
// Nao e um Update qualquer: alem de gravar o status, o backend CANCELA na hora
// todos os avisos da regua que estavam agendados para o contrato e devolve
// quantos foram em `agendamentos_cancelados`. Por isso a acao pede confirmacao
// e mostra esse numero — ver components/Modal/BillingForward.
//
// PROVISORIO: o `status` vai TAMBEM dentro de `data`. O backend deveria ler o
// destino do caminho, mas hoje nao encontra e cai no fallback que procura o
// status no corpo — sem ele no `data`, a rota falha. A correcao da rota esta
// com o Giovani; quando ela ler o caminho, o `status` do corpo pode sair e o
// `data` volta a levar so a `observacao`.
export const Forward = async (id, status, params = {}) => {
  return await PUT(
    `/${table}/${id}/${status}`,
    { ...params, data: { ...(params?.data || {}), status } },
    true
  );
};
